import { render } from "./AddressProgramOderFooter.vue?vue&type=template&id=11ad467d&scoped=true"
import script from "./AddressProgramOderFooter.vue?vue&type=script&lang=js"
export * from "./AddressProgramOderFooter.vue?vue&type=script&lang=js"

import "./AddressProgramOderFooter.vue?vue&type=style&index=0&id=11ad467d&lang=scss&scoped=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11ad467d"]])

export default __exports__